"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultConfig = void 0;
const react_1 = __importDefault(require("react"));
const use_form_1 = __importDefault(require("../../../form/use-form"));
/**
 * This field allows values to be added to a hidden input
 * via JS while keeping the form field hidden.
 *
 * The appendHiddenFieldValues() util function is responsible
 * for adding these values to entityData.
 */
const HiddenInput = (props) => {
    const { path } = props;
    const [{ config }] = (0, use_form_1.default)(path);
    if (!config.isVisible)
        return null;
    return react_1.default.createElement("input", { type: "hidden", name: config.name || config.path });
};
exports.default = HiddenInput;
exports.defaultConfig = {};
//# sourceMappingURL=index.js.map